var _circle, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcEditColor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 15.5,
    r: 15.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4232_71832)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.3815 11.9873L24.2775 11.0913C25.0223 10.3466 25.0223 9.13467 24.2775 8.3898L21.3698 5.48213C20.6251 4.7374 19.4132 4.7374 18.6685 5.48213L17.7725 6.37813L23.3815 11.9873Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.64453 16.5065L17.0022 7.14893L22.6112 12.7579L13.2535 22.1156L7.64453 16.5065Z",
    fill: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05434 17.458L6.26676 21.5361C6.16146 22.0815 6.33303 22.6414 6.72582 23.0342C7.04242 23.3508 7.46757 23.5237 7.90635 23.5237C8.01178 23.5237 8.11807 23.5137 8.22393 23.4932L12.3019 22.7057L7.05434 17.458Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4232_71832"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.6,
    height: 18.6,
    fill: "white",
    transform: "translate(6.2002 4.95996)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEditColor);
export default __webpack_public_path__ + "static/media/ic_editColor.ee06d3d3.svg";
export { ForwardRef as ReactComponent };